import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, ClearSearch } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/ClearSearch";
import customClearOrderHistoryFilter from "@tKgpco/Store/Data/OrderHistory/Handler/CustomClearOrderHistoryFilters";

addToChainBefore(chain, ClearSearch, props => {
    const getOrderHistoryParams = props.getState().pages.orderHistory.getOrdersParameter;
    props.dispatch(customClearOrderHistoryFilter({ clearOrderHistoryFilters: true, getOrderHistoryParams }));
});
